import useContentStack from '../../hooks/useContentStack'
import { ContentStackTypes } from '../../store/Constants'
import { ANALYTICS } from '../../store/AnalyticsConstants'
import React, { useEffect } from 'react'
import classes from './InstallChina.module.scss'
import useAnalytics from '../../hooks/useAnalytics'
import { useAnalyticsProps } from '../../hooks/useAnalyticsProps'
import { CmsDataFetchStatus } from '@jarvis/olex-content-management'
import { renderContentStackInHtml } from '../../utils'
import { renderReplacerTags } from '../../utils/renderReplacerTags'

export default function InstallChina() {
  const { status, pageData } = useContentStack(ContentStackTypes.china_hp_app)
  const analyticsProps = useAnalyticsProps()
  const apkDownloadLink =
    'https://h20614.www2.hp.com/ediags/solutions/software/v3?client=PSW&ModelName=HPSmart&os=Google%20Android'

  const { fireScreenDisplayed, fireHyperLinkClick } = useAnalytics(
    ANALYTICS.SCREENS.INSTALL_CHINA
  )
  const clickLinkHandler = (controlName) => {
    fireHyperLinkClick(controlName, {
      ...analyticsProps,
      detail: apkDownloadLink
    })
  }

  const compareVersions = (v1, v2) => {
    const v1Parts = v1.split('.').map(Number)
    const v2Parts = v2.split('.').map(Number)

    for (let i = 0; i < v1Parts.length; i++) {
      if (v1Parts[i] > v2Parts[i]) return 1
      if (v1Parts[i] < v2Parts[i]) return -1
    }
    return 0
  }

  const fetchHPSmartLinkAndRedirect = async (url) => {
    try {
      const response = await fetch(url)
      const data = await response.json()
      const highestVersionEntry = data.reduce((max, entry) => {
        return compareVersions(entry.Version, max.Version) > 0 ? entry : max
      }, data[0])
      highestVersionEntry.FtpURL = highestVersionEntry.FtpURL.replace(
        'ftp://',
        'https://'
      )
      window.location = highestVersionEntry.FtpURL
    } catch (error) {
      console.error('Error fetching or processing HP link fetch:', error)
    }
  }
  const hpLinkClickHandler = (controlName) => {
    clickLinkHandler(controlName)
    fetchHPSmartLinkAndRedirect(apkDownloadLink)
  }

  const olOnClick = (e) => {
    const element = e.target.closest('a')
    if (!element) return
    if (element.id === 'hp-website') {
      hpLinkClickHandler(ANALYTICS.LINKS.HP_SUPPORT)
    }
  }

  useEffect(() => {
    fireScreenDisplayed(analyticsProps)
  }, [])

  if (status !== CmsDataFetchStatus.LOADED) {
    return <></>
  }

  return (
    <div className={classes.installChina} data-testid="install-china">
      <h2>{pageData?.header}</h2>
      <ol onClick={olOnClick}>
        {pageData.steps?.map((step, stepIndex) => {
          return (
            <li key={stepIndex}>
              <article>
                {renderReplacerTags(step, {
                  MAIN_APP_LINKS: (
                    <>
                      {pageData.main_app_links?.map((link) => {
                        return (
                          <a key={link.title} href={link.href}>
                            {link.title}
                          </a>
                        )
                      })}
                    </>
                  ),
                  OTHER_APP_LINKS: (
                    <>
                      {pageData.other_app_links?.map((link) => {
                        return (
                          <a key={link.title} href={link.href}>
                            {link.title}
                          </a>
                        )
                      })}
                    </>
                  )
                })}
              </article>
            </li>
          )
        })}
      </ol>
      <ul className={classes.features}>
        <h5>{pageData.features_header}</h5>
        {pageData.features_list?.map((feature, featureIndex) => {
          return (
            <li key={featureIndex}>
              {renderContentStackInHtml({
                htmlString: feature
              })}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
